export const webalize = (text) => text
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^[-\s]+|[-\s]+$/g, '')
  .replace(/--+/g, '-');

export const removeHtml = (text) => (
  text.replace(/<[^>]+>/g, '')
);
